import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef, ViewEncapsulation, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API, CONST_AWS_API, COUNTRIES_LIST } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { API as AWS_API } from 'aws-amplify';
import { ValidationService } from 'src/app/core/services/validation.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

declare let window: any;

@Component({
  selector: 'app-ic-media-payment',
  templateUrl: './ic-media-payment.component.html',
  styleUrls: ['./ic-media-payment.component.scss'],
  encapsulation: ViewEncapsulation.None, // Add this line

})
export class IcMediaPaymentComponent implements OnInit {

  @Output('togglePaymentSideMenu') togglePaymentSideMenu: EventEmitter<any> = new EventEmitter();
  @Input('screenFrom') screenFrom: any = "";
  showCCForm: boolean = false;
  billingForm: FormGroup;
  address: string;
  pastedText: any;
  codes: any = {};
  currency: any;
  userInfo: any = {};
  loadCss = `${environment.CONSUMER_PORTAL}assets/custom-css/paystand.css`;
  card: any;
  cardError: string;
  validStripeForm = false;
  taxPercentage = 0;
  taxAmount = 0;
  taxable: boolean = true;
  finalAmount: any;
  invoice_id: any;
  incl: any;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  psKey: any;
  cardId: any;
  currentLocation: any;
  @Input('performer_details') performer_details: any = {};
  reopen: boolean;
  isPaymentSuccess = false;
  ccForm: FormGroup;
  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  isEdit: boolean = false;
  @Input('settingsData') settingsData: any = {};
  @Input('paymentStreamInfo') paymentStreamInfo: any = {};
  @Input('tickets') tickets: any = [];
  paymentType = "pay_per_view";
  streamData: any = {};
  streamInfo: any = {};
  ticketDetails: any = {};
  settingsJSON: any = {};
  processingFee: number = 0;
  currenciesList: any = [];
  minAmount: any;
  bookingFee: any = 0;
  selectedTicket: any;
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  showBillingForm: boolean = false;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  newShippingForm: boolean = false;
  addNewCard: boolean = false;
  selectedBillingAddress: any;
  userInfoSubscription: Subscription;
  currentTheme: any;
  transactionInfoSubscr: Subscription;
  transactionInfo: any;
  currentBlock: any;
  billingAddress: any;
  formStatusSubscr: Subscription;
  selectedTransaction: any;
  amt_without_pf = 0;
  albumUrl: String;
  totalAmount: any;
  currency_for_totAmt: string;
  amt_without_pf1: number;
  crypto_amount: number;
  sliced_crypto_amount: number;
  USD_Rates: any;
  clientDetails: any;
  cryptoToken: any;
  cryptoSymbol: string;
  title: any;
  organization: any;
  constructor(private formBuilder: FormBuilder, private commanSubscribeService: CommanSubscribeService,
    private storageService: StorageService,
    
    private activatedRoute: ActivatedRoute, private toastr: ToastrService, private appPaymentService: AppPaymentTVService,
    private loader: NgxUiLoaderService, private router: Router, private paymentService: PaymentService,
    public dialog: MatDialog,
    private renderer: Renderer2,private commonSubscribeService: CommanSubscribeService,) { }

  ngOnInit() {
    this.currentBlock = "PPV";
    this.currentTheme = this.commanSubscribeService.getThemeColors();
    this.savedCardsListSubscr = this.commanSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0 && this.addressList.length > 0 && this.addressList.billingAddress.length == 0) {
        this.showBillingForm = true;
      }
      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
      }
    })
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.commanSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
    });
    this.totalAmount = this.commanSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf1 = response.amt_without_pf;
      this.crypto_amount = this.commanSubscribeService.convertToCryptoAmount(this.amt_without_pf1, this.USD_Rates[this.currency_for_totAmt])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3)) / Math.pow(10, 3);
    })
    this.formStatusSubscr = this.commanSubscribeService.getFormStatus().subscribe(response => {
      if (response) {
        this.toggleSideMenuClose('close');
      }
    });

    this.selectedCardInfoSubscr = this.commanSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        this.selectedBillingAddress = {};
        this.buildBillingForm();
        this.showBillingForm = false;
        this.addNewCard = false;
        // let country;
        // COUNTRIES_LIST.forEach(element => {
        //   if (element.alpha2code == this.selectedCard.billing_address.country) {
        //     country = element;
        //   }
        // });
        // if (this.selectedCard && this.selectedCard.id) {
        //   let card = this.selectedCard.billing_address;
        //   this.selectedBillingAddress.line1 = card.line1;
        //   this.selectedBillingAddress.line2 = card.line2;
        //   this.selectedBillingAddress.city = card.city;
        //   this.selectedBillingAddress.country = card.country;
        //   this.selectedBillingAddress.state = card.state;
        //   this.selectedBillingAddress.zip = card.postal_code;
        // }
        // if (this.selectedTransaction == "ott") {
        //   this.commanSubscribeService.validateZip(this.selectedCard.billing_address.postal_code, country.name, (result) => {
        //     if (result.status) {
        //       this.codes = result;
        //       let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
        //       this.codes.country = country[0].alpha3code;
        //       this.getTaxPercentage(this.selectedCard.billing_address.postal_code, () => {

        //       });
        //     } else {
        //       this.toastr.error('Invalid zip code');
        //     }
        //   });
        // }
      }
    });

    this.addressListInfoSubscr = this.commanSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList && this.addressList.billingAddress.length > 0) {
        let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
        this.showBillingForm = billingAdd.length > 0 ? true : false;
        if (this.showBillingForm) {
          this.commanSubscribeService.formsValidationSubject.next(false);
        }
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.billingAddress = this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        if (Object.keys(this.selectedBillingAddress).length > 0)
          this.commanSubscribeService.formsValidationSubject.next(true);
        this.buildBillingForm();
      } else if (this.addressList.billingAddress.length == 0 && this.savedCardsList.length == 0) {
        this.showBillingForm = true;
      }
    });

    this.transactionInfoSubscr = this.commanSubscribeService.getTransactionInfo().subscribe(response => {
      this.transactionInfo = response;
      this.card = this.transactionInfo["card"];
      if (this.selectedCard && this.selectedCard.id) {
        this.makePayment('card');
      } else {
        this.makePayment();
      }
    })

    this.performer_details = this.performer_details ? JSON.parse(JSON.stringify(this.performer_details)) : {};
    this.settingsData = this.settingsData ? JSON.parse(JSON.stringify(this.settingsData)) : {};
    this.paymentStreamInfo = this.paymentStreamInfo ? JSON.parse(JSON.stringify(this.paymentStreamInfo)) : {};
    this.tickets = this.tickets ? JSON.parse(JSON.stringify(this.tickets)) : {};


    if (this.router.url.includes('subscribe-payment')) {
      this.screenFrom = "mobile";
    } else {
      this.screenFrom = "directive";
    }

    this.buildCCForm();
    this.buildBillingForm();

    this.currentLocation = this.commanSubscribeService.locationInfo;
    // this.streamInfo = this.paymentStreamInfo.stream_info;
    this.streamInfo = this.paymentStreamInfo.stream_info ? this.paymentStreamInfo.stream_info : this.paymentStreamInfo;
    this.selectedTicket = this.paymentStreamInfo.selectedTicket;
    this.settingsJSON = JSON.parse(this.streamInfo.settings_json);

    if (!this.selectedTicket) {
      this.tickets.forEach(element => {
        if ((element.sessions.includes(this.streamInfo.id))
          && element.ticket_type == 'paid'
        ) {
          if (element.amounts) {
            element.amounts = typeof element.amounts == 'string' ? JSON.parse(element.amounts) : element.amounts;
          }
          this.ticketDetails = element;

        }
      });
    }
    if (this.selectedTicket) {
      if (this.selectedTicket.amounts) {
        this.selectedTicket.amounts = typeof this.selectedTicket.amounts == 'string' ? JSON.parse(this.selectedTicket.amounts) : this.selectedTicket.amounts;
      }
      this.ticketDetails = this.selectedTicket;
    }
    this.currency = this.storageService.getItem('currency') || this.ticketDetails.original_currency || this.ticketDetails.currency;
    this.ticketDetails.original_price = this.ticketDetails.original_price || this.ticketDetails.price;

    // this.getFinalAmount();
    this.buildBillingForm();

    this.commanSubscribeService.getCurrenciesJSON().subscribe(result => {
      Object.keys(result).forEach(element => {
        let value = element + ' - ' + result[element]
        this.currenciesList.push(value);
      })
    });

    this.getPaymentDetails();

    if (this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.user_id) {
      const groupName = this.activatedRoute.snapshot.params.groupName;
      this.albumUrl = environment.CONSUMER_PORTAL + this.activatedRoute.snapshot.params.channelName + (groupName ? '/' + groupName : '') + '/album/' + this.activatedRoute.snapshot.params.tag_category + '/' + this.activatedRoute.snapshot.params.slug_name + '?id=' + this.activatedRoute.snapshot.queryParams.id;
    }
    if (this.ticketDetails.event_id == this.ticketDetails.sessions[0]) {
      this.title = this.paymentStreamInfo.stream_info.stage
    }
    else {
      this.title = `${this.paymentStreamInfo.stream_info.stage}/${this.paymentStreamInfo.stream_info.stream_video_title}`
    }
  }
  ngAfterViewInit() {
    const matWrapper = document.querySelector('.amount-field .mat-form-field-wrapper');

    if (matWrapper) {
      if (Object.keys(this.settingsData).length !== 0) {
        // Apply color dynamically
        this.renderer.setStyle(matWrapper, 'background', this.settingsData.form_font_secondary_color);
      }else{
        this.renderer.removeStyle(matWrapper, 'background');
      }
    }
    this.addStyle();
  }
  calFee(response:any) {
    if (this.currentBlock == "PPV") {
      this.selectedTransaction = response.selectedTransaction;
      this.fee = (this.selectedTransaction == "wallet" || this.selectedTransaction == 'crypto') ? (this.streamInfo.booking_fee_wallet ? this.streamInfo.booking_fee_wallet : 0) / 100 : (this.streamInfo.booking_fee ? this.streamInfo.booking_fee : 0) / 100;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.bookingFee = this.streamData.amount * this.fee;
        this.bookingFee = Number(this.bookingFee.toFixed(2));
        this.amt_without_pf = this.streamData.amount + this.bookingFee + this.taxAmount;
        this.processingFee = 0;
        this.finalAmount = this.amt_without_pf;
      } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
        this.processingFee = 0;
        this.bookingFee = this.streamData.amount * this.fee;
        this.bookingFee = Number(this.bookingFee.toFixed(2));
        this.amt_without_pf = this.streamData.amount + this.bookingFee + this.taxAmount;
        this.processingFee = (this.amt_without_pf * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.processingFee = Number(this.processingFee.toFixed(2));
        this.finalAmount = Number(this.amt_without_pf) + this.processingFee;
      }
      this.calTax();
      this.amt_without_pf = this.streamData.amount + this.bookingFee + this.taxAmount;
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": Number(this.amt_without_pf)
      }
      this.commanSubscribeService.totalAmountSubject.next(data);
    }
  }

  newCard() {
    this.addNewCard = true;
    this.selectedCard = {};
    if (this.addressList.length > 0 && this.addressList.billingAddress.length == 0)
      this.showBillingForm = true;
    this.commanSubscribeService.selectedCardSubject.next(false);
  }

  buildBillingForm() {
    this.billingForm = this.formBuilder.group({
      amount: ["", Validators.required],
      address1: ["", Validators.required],
      address2: [""],
      city: ["", Validators.required],
      state: ["", Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.countriesList, 'name')]],
      zip: ["", Validators.required],
    });
    this.billingForm.patchValue({
      amount: Number(this.ticketDetails.price).toFixed(2)
    });
    this.billingForm.get("amount").disable();
    // Now add validators after the form is initialized and values are set
    setTimeout(() => {
      this.billingForm.get('address1').setValidators(Validators.required);
      this.billingForm.get('city').setValidators(Validators.required);
      this.billingForm.get('state').setValidators(Validators.required);
      this.billingForm.get('country').setValidators([
        Validators.required,
        ValidationService.autoCompleteValueSelected(this.countriesList, 'name')
      ]);
      this.billingForm.get('zip').setValidators(Validators.required);
      // Update validity without marking as touched
      Object.keys(this.billingForm.controls).forEach(controlName => {
        const control = this.billingForm.get(controlName);
        control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      });
    });
    this.prepare();
  }

  buildCCForm() {
    this.ccForm = this.formBuilder.group({
      nameOnCard: ["", Validators.required],
      cardNumber: ["", Validators.required],
      expDate: ["", Validators.required],
      cvv: ["", Validators.required],
      month: [""],
      year: [""]
    });
  }

  toggleSideMenuClose(from) {
    // const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    // const albumId = this.commanSubscribeService.extractIdFromUrl(this.router.url);
    

    // (window as any).umami?.track(`Album ${albumId} payment cancelled - ${userId}`)
    // const u_payload = {
    //   actionType: "network",
    //   metaData: `Album ${albumId} payment cancelled123`,
    //   clickAction: `album`
    // }
    // this.commonSubscribeService.sendTriggeredEvent(u_payload);

    if (this.screenFrom == "directive") {
      this.togglePaymentSideMenu.emit(from);
    }
  }

  get getCCValue() {
    return this.ccForm.getRawValue();
  }
  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  onPasteLocation(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText);
  }

  billingFormLat: any;
  billingFormLong: any;
  getSelectedAddress(val) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    this.loader.start();
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      this.commanSubscribeService.getAddress(val, (result) => {
        this.loader.stop();
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }

          this.billingFormLat = place.geometry.location.lat;
          this.billingFormLong = place.geometry.location.lng;
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              // if (element.types[0] == "country" && element.long_name)
              //   myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          this.billingForm.patchValue({
            address1: myAddress.address1 ? myAddress.address1 : this.address,
            address2: myAddress.address2,
            city: myAddress.city,
            state: myAddress.state,
            // country: myAddress.country,
            zip: myAddress.zip
          });

        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }


  proceed() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commanSubscribeService.extractIdFromUrl(this.router.url);
    console.log("stream Info in proceed:", this.streamInfo);
    
    (window as any).umami?.track(`Album ${albumId} payment proceeded - ${userId}`)
        console.log("stream Info in proceed:", this.streamInfo);

    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} payment proceeded`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo?.organization_id || null,
      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    if ((this.billingForm.invalid && this.getBillingValue.zip == '') && (Object.keys(this.selectedCard).length == 0 && (this.selectedBillingAddress && Object.keys(this.selectedBillingAddress).length == 0))) {
      if (this.billingForm.invalid) {
        // Mark all fields as touched to show validation messages
        Object.keys(this.billingForm.controls).forEach(key => {
          this.billingForm.get(key).markAsTouched();
        });
      }
      this.toastr.error('Please enter complete billing address');
      return;
    }
    if (this.billingForm.valid || (Object.keys(this.selectedBillingAddress).length > 0) || this.billingForm.valid) {
      // this.validateZip((valid) => {
      this.commanSubscribeService.billingInfoSubject.next(this.getBillingValue);
      this.commanSubscribeService.formsValidationSubject.next(true);
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        COUNTRIES_LIST.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      if (this.selectedCard && this.selectedCard.id) {
        let card = this.selectedCard.billing_address;
        this.selectedBillingAddress.line1 = card.line1;
        this.selectedBillingAddress.line2 = card.line2;
        this.selectedBillingAddress.city = card.city;
        this.selectedBillingAddress.country = card.country;
        this.selectedBillingAddress.state = card.state;
        this.selectedBillingAddress.zip = card.postal_code;
      }
      this.calTax();
    }
  }

  calTax() {
    let country;
    if (this.selectedCard && this.selectedCard.id) {
      COUNTRIES_LIST.forEach(element => {
        if (element.alpha2code == this.selectedCard.billing_address.country) {
          country = element;
        }
      });
    }
    let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
    let cName = this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : country && country.name ? country.name : this.getBillingValue.country.name;
    this.commanSubscribeService.validateZip(zip, cName, (result) => {
      if (result.status) {
        this.isEdit = !this.isEdit;
        // this.billingForm.disable();
        this.codes = result;
        let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
        this.codes.country = country[0].alpha3code;
        if (result.status) {
          this.getTaxPercentage(zip, () => {
            // setTimeout(() => {
            // }, 1000);
            this.showCCForm = true;
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      }
    });
  }

  fee = 0;
  getTaxPercentage(zip, callback) {
    let amount = Number(this.streamData.amount);
    amount = Number(amount.toFixed(2));
    let streamAmount = 0;
    let liveAmount = 0;
    let addOnAmount = 0;
    // if (this.streamInfo.booking_fee != 0) {
    //   this.fee = (this.streamInfo.booking_fee) / 100;
    // }
    //this.fee = this.selectedTransaction == "wallet" ? (this.streamInfo.booking_fee_wallet) / 100 : (this.streamInfo.booking_fee)/100;
    streamAmount = amount;
    addOnAmount = this.ticketDetails.add_ons ? addOnAmount += this.ticketDetails.price : 0;
    streamAmount = streamAmount + streamAmount * this.fee;
    addOnAmount = addOnAmount + addOnAmount * this.fee;

    streamAmount = Number(streamAmount.toFixed(2));
    liveAmount = Number(liveAmount.toFixed(2));
    addOnAmount = Number(addOnAmount.toFixed(2));


    let data: any = {
      vod: true,
      access_token: this.userInfo.access_token,
      amount: streamAmount,
      addOnAmount: addOnAmount,
      stream_id: this.streamInfo.parent_streams_id,
      payment_type: this.paymentType,
      currency: this.currency,
      address: {
        street1: this.getBillingField("address1", "line1"),
        city: this.getBillingField("city"),
        state: this.getBillingField("state"),
        state_code: this.codes?.state ?? this.selectedBillingAddress?.state_code ?? "",
        zip: this.getBillingField("zip"),
        country: this.getBillingField("city"),
        country_code: this.codes?.country ?? this.selectedBillingAddress?.country_code ?? ""
      }
    };

    this.paymentService.calculateTax(data, (result) => {
      if (result.status == 0) {
        this.taxPercentage = result.data.taxPercentage;
        this.taxAmount = Number(result.data.tax);
        this.taxAmount = Number(this.taxAmount.toFixed(2));
        this.finalAmount = result.data.finalAmount;
        this.finalAmount = Number(this.streamData.amount) + Number(this.bookingFee) + Number(this.taxAmount);
        this.finalAmount = Number(this.finalAmount.toFixed(2));
        this.amt_without_pf = this.finalAmount = Number(this.finalAmount);
        this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
        //adding processing fee only for ott
        if(this.selectedTransaction === 'ott'){
          this.finalAmount += this.processingFee;
        }
        this.finalAmount = Number(this.finalAmount.toFixed(2));
        let data = {
          "total_amount": this.finalAmount,
          "currency": this.currency,
          "processing_fee": this.processingFee,
          "amt_without_pf": Number(this.amt_without_pf)
        }
        this.commanSubscribeService.totalAmountSubject.next(data);
        this.invoice_id = result.data.invoice_id;
        this.incl = result.data.incl;
        this.billingForm.patchValue({
          amount: Number(this.ticketDetails.price).toFixed(2)
        });
        this.billingForm.get("amount").disable();

        if (this.incl)
          this.taxAmount = 0;
        callback();
      } else {
        this.toastr.error('Unable to get tax');
      }
    });
  }

  editAddress() {
    this.isEdit = !this.isEdit;
    this.showCCForm = false;
    this.billingForm.enable();
  }

  prepare() {
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.billingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }

    if (this.router.url.includes('subscribe-payment')) {
      //here this condition will use for mobile payment
    } else {
      this.userInfo = JSON.parse(JSON.stringify(this.commanSubscribeService.userInfo));
      this.userInfo = this.userInfo || {};
    }
  }


  getPaymentDetails() {
    let resObj: any = {};
    resObj.stream = {
      id: this.streamInfo.id,
      stream_video_title: this.streamInfo.stream_video_title,
      organization_id: this.streamInfo.organization_id,
      currency: this.streamInfo.currency_type,
      stream_amounts: this.streamInfo.displayAmounts,
      publish_date_time: this.streamInfo.publish_date_time,
      video_thumbnail_image: this.streamInfo.video_thumbnail_image,
      video_banner_image: this.streamInfo.video_banner_image,
      performer_id: this.streamInfo.performer_id,
      user_first_name: this.streamInfo.user_first_name,
      user_last_name: this.streamInfo.user_last_name,
      user_display_name: this.streamInfo.user_display_name,
      channel_name: this.streamInfo.channel_name,
      number_of_creators: this.streamInfo.number_of_creators,
      stream_status: this.streamInfo.stream_status,
      currency_type: this.streamInfo.currency_type,
      expected_end_date_time: this.streamInfo.expected_end_date_time,
      slug: this.streamInfo.slug,
      selected_type: this.streamInfo.selected_type,
      vod_video_audio: this.streamInfo.vod_video_audio || ''
    };
    resObj.status = 0;
    resObj.message = "Success";
    resObj.paymentType = this.paymentType;
    resObj.stream_id = this.streamInfo.parent_streams_id;

    this.streamData = resObj.stream || {};
    this.paymentType = resObj.paymentType;
    if (this.streamData && this.paymentType == "pay_per_view") {
      this.streamData.amount = this.ticketDetails.price;
      this.streamData.currency = this.currency;
      this.fee = (this.streamInfo.booking_fee ? this.streamInfo.booking_fee : 0) / 100
      this.bookingFee = this.streamData.amount * this.fee;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
      this.finalAmount = this.streamData.amount + this.bookingFee + this.taxAmount;
    }

    let amount = this.finalAmount;
    if (amount) {
      amount = Number(amount).toFixed(2);
    }
    this.billingForm.patchValue({
      amount: this.streamData.amount
    });
    this.billingForm.get("amount").disable();
    this.getCurrencyRates(this.currency);


  }

  currencyVal: any;
  changeCurrency(event) {
    let getVal = event?.value.split(' -');
    if(event){
      this.currency = getVal[0];
    }
    // this.storageService.setItem('currency', getVal[0]);

    let is_found_currency = false;
    for (let i = 0; i < this.ticketDetails.amounts.length; i++) {
      const element = this.ticketDetails.amounts[i];
      if (element.currency_type == this.currency) {
        this.minAmount = this.streamData.amount = element.non_subscriber;
        is_found_currency = true;
        break;
      }
    }
    if (!is_found_currency) {
      Object.keys(this.rates).forEach(rates => {
        if (this.currency == rates)
          this.minAmount = this.rates[rates];
      });
      for (let i = 0; i < this.ticketDetails.amounts.length; i++) {
        const element = this.ticketDetails.amounts[i];
        if (element.currency_type == this.paymentStreamInfo.stream_info.currency_type) {
          this.ticketDetails.original_price = this.streamData.amount = element.non_subscriber;
        }
      }
      this.ticketDetails.price = this.streamData.amount = this.minAmount * this.ticketDetails.original_price * 1.025;
    } else {
      this.ticketDetails.price = this.streamData.amount = this.minAmount;
    }

    // this.getFinalAmount();


    this.bookingFee = this.streamData.amount * this.fee;
    this.bookingFee = Number(this.bookingFee.toFixed(2));
    this.streamData.currency = this.currency;
    this.billingForm.patchValue({
      amount: Number(this.ticketDetails.price).toFixed(2)
    });
    this.billingForm.get("amount").disable();
  }

  selectCountry(country) {
    this.countryChanged = false
    this.billingCountry = country.value;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    this.billingForm.patchValue({
      address1: "",
      address2: "",
      city: "",
      state: "",
      // country: "",
      zip: ""
    });
    setTimeout(() => { this.countryChanged = true });
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry() {
    if (this.getBillingValue.country) {
      let countriesList = JSON.parse(JSON.stringify(COUNTRIES_LIST));
      const filterValue = this.getBillingValue.country.toLowerCase();
      this.countriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
    } else {
      this.countriesList = [];
    }
  }

  toggleLoader(state) {
    var overlay = document.getElementsByClassName('ngx-overlay');
    overlay[0]['style'].display = state;
    if (state == 'none') {
      this.loader.stop();
    }
  }

  getBillingField(billingKey, selectedKey = billingKey) {
    const billingVal = this.getBillingValue?.[billingKey];
    const selectedVal = this.selectedBillingAddress?.[selectedKey];
    if (billingVal !== undefined && billingVal !== null && billingVal !== "") {
      return billingVal;
    }
    if (selectedVal !== undefined && selectedVal !== null && selectedVal !== "") {
      return selectedVal;
    }
    return "";
  }

  async makePayment(from?) {
    if (this.streamInfo.parent_streams_id == 0) {
      this.streamInfo.parent_streams_id = this.streamData.id
    }
    let amount, finalAmount, name;
    name = this.userInfo.user_display_name || this.userInfo.display_name
    if (this.paymentType == 'pay_per_view') {
      amount = this.streamData.amount;
      finalAmount = this.finalAmount;
    } else {
      amount = finalAmount = this.finalAmount;
    }
    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      let data: any = {
        amount: this.selectedTransaction == "crypto" ? this.crypto_amount : amount,
        finalAmount: this.selectedTransaction == "crypto" ? this.crypto_amount : finalAmount,
        currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.currency.toLowerCase() || 'gbp',
        organization_id: this.streamData.organization_id,
        // performer_id: JSON.stringify(this.streamData.performer_id),
        stream_id: JSON.stringify(this.streamData.parent_streams_id),
        paymentType: this.paymentType,
        payment_type: this.paymentType,
        response: null,
        transaction_id: '',
        name: name,
        network_group_id: this.streamInfo?.network_group_id ? this.streamInfo.network_group_id : '',
      };

      if(data['ref_code']!==undefined && localStorage.getItem('affiliateReferralCode')){
        data['ref_code']=JSON.parse(localStorage.getItem('affiliateReferralCode') || '""')
        data['referral_code']=JSON.parse(localStorage.getItem('affiliateReferralCode') || '""')
      }
      // data['ticket_ids'] = [this.ticketDetails.id];
      data['ticket_ids'] = [this.streamInfo.id];
      data['zip'] = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "";
      data['invoice_id'] = this.invoice_id;
      data['tax_amount'] = this.taxAmount;
      data['tax_rate'] = this.taxPercentage;
      data['stream_id'] = this.streamInfo.parent_streams_id;
      data['streamInfo'] = this.streamData;
      data['streamInfo']['id'] = this.streamInfo.parent_streams_id;
      data['streamInfo']['event_id'] = this.streamInfo.parent_streams_id;
      data['country'] = this.getBillingValue.country.name;
      data['network_group_id'] = this.streamInfo.network_group_id ? this.streamInfo.network_group_id : "";
      data.ticket_type_name = this.ticketDetails.ticket_type_name;
      data['address'] = {
        street1: this.getBillingField("address1", "line1"),
        city: this.getBillingField("city"),
        state: this.getBillingField("state"),
        state_code: this.codes?.state ?? this.selectedBillingAddress?.state_code ?? "",
        zip: this.getBillingField("zip"),
        country: this.getBillingField("country"),
        country_code: this.codes?.country ??
                this.selectedBillingAddress?.country_code ??
                "",
        lat: this.billingFormLat,
        lng: this.billingFormLong
      };
      data['exchange_rate'] = this.minAmount;
      data['fee_to_fan'] = this.settingsJSON.fee_to_fan;
      data['creator_currency'] = this.streamInfo.currency_type.toLowerCase();
      data['processing_fee_amount'] = this.processingFee;
      data['processing_fee_percentage'] = environment.processing_fee;
      data['processing_fee_fixed'] = environment.fee_percentage;
      // data['booking_fee'] = this.streamInfo.booking_fee;
      data['booking_fee'] = this.bookingFee;
      if (this.streamInfo.stream_payment_mode == 'paid') {
        let tickets = [{
          'id': this.ticketDetails.id,
          'for_self': 1,
          'limited_tickets': 0,
          'name': this.ticketDetails.title,
          'sessions': this.ticketDetails.sessions,
          'networking': this.ticketDetails.networking,
          'live': 0,
          'live_qa': this.ticketDetails.live_qa,
          'expo': this.ticketDetails.expo,
          'price': this.ticketDetails.price,
          'amounts':this.ticketDetails.amounts,
          user: {
            'id': this.userInfo.id,
            'first_name': this.userInfo.user_first_name,
            'last_name': this.userInfo.user_last_name,
            'email': this.userInfo.email
          }
        }];
        data.tickets = tickets;
        data.timezone_offset = new Date().getTimezoneOffset();
      }
      let billingAddress;
      billingAddress = {
        'line1': this.getBillingValue.address1,
        'line2': this.getBillingValue.address2,
        'city': this.getBillingValue.city,
        'state': this.getBillingValue.state,
        'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : "",
        'postal_code': this.getBillingValue.zip
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': billingAddress
        }
      }
      if (this.userInfo && !this.userInfo.is_guest) {
        if (this.getBillingValue.address1) {
          data['new_billing'] = {
            "type": 'billing',
            "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
            "line1": this.getBillingValue.address1,
            "line2": this.getBillingValue.address2,
            "city": this.getBillingValue.city,
            "state": this.getBillingValue.state,
            "state_code": this.codes.state,
            "country": this.getBillingValue.country.name,
            "country_code": this.codes.country,
            "zip": this.getBillingValue.zip,
            "remove_default": false,
            "default": false,
          }
        }
      }
      if (this.transactionInfo['mode'] == 'wallet' || this.transactionInfo["mode"] == 'crypto') {
        this.completeTransaction(data, this.transactionInfo['paymentIntent']);
        return;
      }
      let url = API.GET_CLIENT_SECRET;
      this.loader.start();
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          data.transaction_id = result['transaction_id'];
          // this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            console.log(result);
            if (result.error) {
              this.toastr.error(result.error.message);
              this.loader.stop();
              this.commanSubscribeService.updatePaymentBtnSubject.next(true);
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                this.completeTransaction(data, result['paymentIntent']);
              }
            }
          });
        } else {
          this.toastr.error(result.message)
          this.loader.stop();
        }
      }, error => {
        this.toastr.error(error);
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    }
  }

  isMobileAPP: boolean = false;
  completeTransaction(data, result) {
    data.response = result;
    data.timezone_offset = new Date().getTimezoneOffset();
    data["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    data["transaction_amount"] = this.transactionInfo['transaction_amount'];
    data["save_card"] = this.transactionInfo['save_card'];
    data["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    console.log('+++++++++++',data)
    let url = API.PAYMENT_SUCCESSS;
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      this.loader.stop();
      if (result['message'] == 'Success') {
        this.toastr.success("Payment completed successfully");
        this.commanSubscribeService.updateAvailBalSubject.next(true);
        this.isPaymentSuccess = true;
        this.commanSubscribeService.sendTriggeredEvent({
          actionType: "purchase",
          clickAction: "PAYMENT_SUCCESS",
          metaData: {
            amount: data['transaction_amount'],
            title: `Payment completed successfully`,
            timeStamp: new Date().toISOString()
          },
          organizationId: this.streamInfo?.organization_id || null,
          networkGroupId: this.streamInfo?.network_group_id || null,
        });
        if (this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.user_id) {
          this.isMobileAPP = true;
          return;
        }
        // this.backToLastPage();
        this.toggleSideMenuClose("success");

      } else {
        this.commanSubscribeService.updatePaymentBtnSubject.next(true);
        this.toastr.error(result['message']);
        this.loader.stop();
      }
    });
  }

  backToLastPage() {
    if (this.screenFrom == "directive" && this.activatedRoute.snapshot.queryParams.returnUrl) {
      this.router.navigate([this.activatedRoute.snapshot.queryParams.returnUrl]);
    }
  }

  rates: any = [];
  getCurrencyRates(currency) {
    if (this.streamInfo.currency_type == 'USD' || this.streamInfo.currency_type == 'GBP') {
      currency = this.streamInfo.currency_type;
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + currency;
    this.loader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.loader.stop();
        this.rates = response['data']['Data']['rates'];
      }
      if (this.currentLocation && this.currentLocation.currency) {
        this.currenciesList.forEach(element => {
          let getVal = element.split(' -');
          let getCode = this.currentLocation.currency.code.includes('\"') ? JSON.parse(this.currentLocation.currency.code) : this.currentLocation.currency.code;
          let currencyType = this.currency ? this.currency : getCode;
          if (getVal[0] == currencyType) {
            this.currencyVal = element;
            this.currency = getVal[0];
            this.changeCurrency(null)
            this.storageService.setItem('currency', getVal[0]);
            Object.keys(this.rates).forEach(rates => {
              if (this.currency == rates)
                this.minAmount = this.rates[rates];
            });
          }
        });
      }
      if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
        this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
          if (val == "fail") {
            this.currentLocation = {};
          } else {
            this.currentLocation = json;
          }
          setTimeout(() => {
            // this.initiateCardElement();
            this.prepare();
          }, 1000);
        });
      } else {
        setTimeout(() => {
          // this.initiateCardElement();
          this.prepare();
        }, 1000);
      }

    }).catch(error => {
      this.loader.stop();
    });
  }

  addStyle(){
    const dynamicColor = this.settingsData?.form_font_secondary_color;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);
    //mat-select-dropdown
    document.documentElement.style.setProperty('--select-panel-bg', this.settingsData?.form_bg_primary_color);
    document.documentElement.style.setProperty('--select-panel-text', this.settingsData?.form_font_secondary_color);
    document.documentElement.style.setProperty('--select-panel-text-color', this.settingsData?.form_font_secondary_color);
    document.documentElement.style.setProperty('--select-panel-text-hover', this.settingsData?.font_secondary_color);
    //dropdown selected value
    document.documentElement.style.setProperty('--select-value-text', this.settingsData?.form_font_secondary_color);
  }

  ngOnDestroy() {
    this.card = '';
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.transactionInfoSubscr) {
      this.transactionInfoSubscr.unsubscribe();
    }
    if (this.formStatusSubscr) {
      this.formStatusSubscr.unsubscribe();
    }
    if (this.totalAmount) {
      this.totalAmount.unsubscribe();
    }
  }


}
